function RenderSlider(element) {
  var _this = $(element),
        _owl = _this,
        _config = _this.data(),
        _animateOut = _this.data('animateout'),
        _lazyloading = _this.data('lazyload'),
        _loop = _this.data('loop'),
        _animateIn = _this.data('animatein'),
        _slidespeed = _this.data('slidespeed'),
        _paginationSpeed = _this.data('paginationSpeed'),
        _dots = _this.data('dots')

      _config.navText = ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>']
      if (typeof _animateOut != 'undefined') {
        _config.animateOut = _animateOut
      }
      if (typeof _loop != 'undefined') {
        _config.loop = _loop
      }
      if (typeof _animateIn != 'undefined') {
        _config.animateIn = _animateIn
      }
      if (typeof _lazyloading != 'undefined') {
        _config.lazyloading = _lazyloading
      }
      if (typeof _slidespeed != 'undefined') {
        _config.smartSpeed = _slidespeed
      }
      if (typeof _paginationSpeed != 'undefined') {
        _config.paginationSpeed = _paginationSpeed
      }
      if (typeof _dots != 'undefined') {
        _config.dots = _dots
      }
      if ($('body').hasClass('rtl')) {
        _config.rtl = true
      }
      _owl.on('drag.owl.carousel', function () {
        _owl.addClass('owl-changed')
        setTimeout(
          function () {
            _owl.removeClass('owl-changed')
          },
          _config.smartSpeed,
          _config.paginationSpeed
        )
      })
      _owl.on('mouseover', function (e) {
        var data = $(e.currentTarget).data('owl.carousel')
        if (data.settings.autoplay) {
          $(e.currentTarget).trigger('stop.owl.autoplay')
        }
      })
      _owl.on('mouseleave', function (e) {
        var data = $(e.currentTarget).data('owl.carousel')
        if (data.settings.autoplay) {
          _owl.trigger('play.owl.autoplay', [5000])
        }
      })

      if (_config) {
        _config.responsive = {
          0: {
            items: 1,
            nav: true,
          },
          600: {
            items: 1,
            nav: true,
          },
          1000: {
            items: 1,
            nav: true,
            loop: true,
          },
          1900: {
            items: 1,
            nav: true,
            loop: true,
          },
        }
      }

      _owl.owlCarousel(_config)
}

export default RenderSlider
